import { FaxInbox, FaxOutbox, SendFaxResponse } from "../interfaces/fax"
import { Types } from "../types"
import { SetResetFaxProps, deleteFaxInboxItemError, deleteFaxInboxItemRequest, deleteFaxInboxItemSuccess, downloadFaxInboxFileError, downloadFaxInboxFileRequest, downloadFaxInboxFileSuccess, downloadFaxOutboxFileError, downloadFaxOutboxFileRequest, downloadFaxOutboxFileSuccess, getCustomerActiveFaxNumberErrorType, getCustomerActiveFaxNumberRequestType, getCustomerActiveFaxNumberSuccessType, getCustomerFaxNumbersError, getCustomerFaxNumbersRequest, getCustomerFaxNumbersSuccess, getCustomerHasIvrProductError, getCustomerHasIvrProductRequest, getCustomerHasIvrProductSuccess, getFaxInboxError, getFaxInboxRequest, getFaxInboxSuccess, getFaxOutboxError, getFaxOutboxRequest, getFaxOutboxSuccess, resendFaxErrorType, resendFaxRequestType, resendFaxSuccessType, sendFaxError, sendFaxRequest, sendFaxSuccess } from "../types/fax/actionTypes"
import { ErrorPayLoad, getFaxInboxPayload, getFaxOutboxPayload, sendFaxPayload } from "../types/fax/apiRequestTypes"




export const getFaxInboxRequestAction = (payload: getFaxInboxPayload): getFaxInboxRequest => ({
    type: Types.GET_FAX_INBOX_REQUEST,
    payload
})

export const getFaxInboxSuccessAction = (response: FaxInbox): getFaxInboxSuccess => ({
    type: Types.GET_FAX_INBOX_SUCCESS,
    response
})

export const getFaxInboxErrorAction = (payload: ErrorPayLoad): getFaxInboxError => ({
    type: Types.GET_FAX_INBOX_ERROR,
    payload
})



export const getFaxOutboxRequestAction = (payload: getFaxOutboxPayload): getFaxOutboxRequest => ({
    type: Types.GET_FAX_OUTBOX_REQUEST,
    payload
})

export const getFaxOutboxSuccessAction = (response: FaxOutbox): getFaxOutboxSuccess => ({
    type: Types.GET_FAX_OUTBOX_SUCCESS,
    response
})

export const getFaxOutboxErrorAction = (payload: ErrorPayLoad): getFaxOutboxError => ({
    type: Types.GET_FAX_OUTBOX_ERROR,
    payload
})



export const sendFaxRequestAction = (payload: FormData): sendFaxRequest => ({
    type: Types.SEND_NEW_FAX_REQUEST,
    payload
})

export const sendFaxSuccessAction = (response: any): sendFaxSuccess => ({
    type: Types.SEND_NEW_FAX_SUCCESS,
    response
})

export const sendFaxErrorAction = (payload: ErrorPayLoad): sendFaxError => ({
    type: Types.SEND_NEW_FAX_ERROR,
    payload
})


export const getCustomerFaxNumbersRequestAction = (): getCustomerFaxNumbersRequest => ({
    type: Types.GET_CUSTOMER_FAX_NUMBERS_REQUEST,
})

export const getCustomerFaxNumbersSuccessAction = (response: any): getCustomerFaxNumbersSuccess => ({
    type: Types.GET_CUSTOMER_FAX_NUMBERS_SUCCESS,
    response
})

export const getCustomerFaxNumbersErrorAction = (payload: ErrorPayLoad): getCustomerFaxNumbersError => ({
    type: Types.GET_CUSTOMER_FAX_NUMBERS_ERROR,
    payload
})


export const getHasCustomerIvrProductRequestAction = (): getCustomerHasIvrProductRequest => ({
    type: Types.GET_HAS_CUSTOMER_IVR_PRODUCT_REQUEST,

})

export const getHasCustomerIvrProductSuccessAction = (response: any): getCustomerHasIvrProductSuccess => ({
    type: Types.GET_HAS_CUSTOMER_IVR_PRODUCT_SUCCESS,
    response
})

export const getHasCustomerIvrProductErrorAction = (payload: ErrorPayLoad): getCustomerHasIvrProductError => ({
    type: Types.GET_HAS_CUSTOMER_IVR_PRODUCT_ERROR,
    payload
})
//////////////////////////===========================


export const downloadFaxInboxFileRequestAction = (payload: string): downloadFaxInboxFileRequest => ({
    type: Types.GET_DOWNLOAD_INBOX_FILE_REQUEST,
    payload

})

export const downloadFaxInboxFileSuccessAction = (response: any): downloadFaxInboxFileSuccess => ({
    type: Types.GET_DOWNLOAD_INBOX_FILE_SUCCESS,
    response
})

export const downloadFaxInboxFileErrorAction = (payload: ErrorPayLoad): downloadFaxInboxFileError => ({
    type: Types.GET_DOWNLOAD_INBOX_FILE_ERROR,
    payload
})
///--------------------------------------------

export const downloadFaxOutboxRequestAction = (payload: string): downloadFaxOutboxFileRequest => ({
    type: Types.GET_DOWNLOAD_OUTBOX_FILE_REQUEST,
    payload
})

export const downloadFaxOutboxSuccessAction = (response: any): downloadFaxOutboxFileSuccess => ({
    type: Types.GET_DOWNLOAD_OUTBOX_FILE_SUCCESS,
    response
})

export const downloadFaxOutboxErrorAction = (payload: ErrorPayLoad): downloadFaxOutboxFileError => ({
    type: Types.GET_DOWNLOAD_OUTBOX_FILE_ERROR,
    payload
})
//-----------------------------------------------


export const deleteFaxInboxItemRequestAction = (payload: string): deleteFaxInboxItemRequest => ({
    type: Types.GET_DELETE_INBOX_ITEM_REQUEST,
    payload
})

export const deleteFaxInboxItemSuccessAction = (response: any): deleteFaxInboxItemSuccess => ({
    type: Types.GET_DELETE_INBOX_ITEM_SUCCESS,
    response
})

export const deleteFaxInboxItemErrorAction = (payload: ErrorPayLoad): deleteFaxInboxItemError => ({
    type: Types.GET_DELETE_INBOX_ITEM_ERROR,
    payload
})

//-----------------------------------------------


export const resendFaxRequestAction = (payload: string): resendFaxRequestType => ({
    type: Types.GET_RESEND_FAX_REQUEST,
    payload
})

export const resendFaxSuccessAction = (response: SendFaxResponse): resendFaxSuccessType => ({
    type: Types.GET_RESEND_FAX_SUCCESS,
    response
})

export const resendFaxErrorAction = (payload: ErrorPayLoad): resendFaxErrorType => ({
    type: Types.GET_RESEND_FAX_ERROR,
    payload
})

export const getCustomerActiveFaxNumberRequestAction = (): getCustomerActiveFaxNumberRequestType => ({
    type: Types.GET_CUSTOMER_ACTIVE_FAX_NUMBER_REQUEST,
})

export const getCustomerActiveFaxNumberSuccessAction = (response: any): getCustomerActiveFaxNumberSuccessType => ({
    type: Types.GET_CUSTOMER_ACTIVE_FAX_NUMBER_SUCCESS,
    response
})

export const getCustomerActiveFaxNumberErrorAction = (payload: ErrorPayLoad): getCustomerActiveFaxNumberErrorType => ({
    type: Types.GET_CUSTOMER_ACTIVE_FAX_NUMBER_ERROR,
    payload
})



export const resetFaxPropsAction = (): SetResetFaxProps => ({
    type: Types.RESET_FAX_PROPS,
})
